import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '@/lib/api/client'
import type { ArtifactData } from '@shared/types/artifact'

export default function ArtifactPage() {
  const { id } = useParams<{ id: string }>()
  const [artifact, setArtifact] = useState<ArtifactData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!id) return

    async function fetchArtifact() {
      try {
        setLoading(true)
        const { data, error: fetchError } = await api.api.artifacts({ id: id! }).get()

        if (fetchError || !data?.artifact) {
          setError('Artifact not found')
          return
        }

        setArtifact(data.artifact)
      } catch (err) {
        console.error('Error fetching artifact:', err)
        setError('Failed to load artifact')
      } finally {
        setLoading(false)
      }
    }

    fetchArtifact()
  }, [id])

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg">Loading artifact...</div>
      </div>
    )
  }

  if (error || !artifact) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg text-red-500">
          {error || 'Artifact not found'}
        </div>
      </div>
    )
  }

  return (
    <div className="h-screen w-full">
      <iframe
        srcDoc={artifact.content}
        title={artifact.name}
        className="h-full w-full border-0"
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  )
}
